/**
 * Removes hyphenation by overriding the default hyphenation method
 * https://react-pdf.org/advanced#hyphenation
 */

import { FontStore } from '@react-pdf/types/font';

export default function removeHyphenation (Font: FontStore) {
  Font.registerHyphenationCallback((word: string) => { return [word]; });
}
